const routeBaseName = "reports";
export const reportsRouteBasePath = `reports`;
export const previewRouteBasePath = `preview`;

export const reportsRoutesNames = {
  root: routeBaseName,
  single: () => `${reportsRoutesNames.root}.single`,
  list: () => `${reportsRoutesNames.root}.reports`,
};

export const reportsRoutes: any = [
  {
    path: reportsRouteBasePath,
    name: reportsRoutesNames.root,
    component: () => import("@/modules/reports/views/layouts/Default.vue"),
    meta: {
      auth: true,
      scope: "reporting:read",
      scrollTop: true,
    },
    children: [
      {
        name: reportsRoutesNames.list(),
        path: "",
        component: () => import("@/modules/reports/views/ReportsList.vue"),
      },
    ],
  },
  {
    path: previewRouteBasePath,
    component: () => import("@/modules/reports/views/layouts/Preview.vue"),
    meta: {
      auth: true,
      scope: "reporting:read",
    },
    children: [
      {
        path: ":id",
        name: reportsRoutesNames.single(),
        component: () => import("@/modules/reports/views/Report.vue"),
      },
    ],
  },
];
